import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

export const parseHours = (s) => {
  const n = parseFloat(String(s ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
};
const fmt = (n) => (n == null || Number.isNaN(Number(n)) ? "" : String(n).replace(".", ","));

export function HoursInput({ value, onChange, className = "", testId }) {
  const [raw, setRaw] = useState(fmt(value));
  useEffect(() => {
    if (parseHours(raw) !== Number(value)) setRaw(fmt(value));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Input
      type="text"
      inputMode="decimal"
      value={raw}
      onChange={(e) => {
        const v = e.target.value.replace(/[^0-9.,]/g, "").replace(/^([^.,]*[.,])(.*)$/, (_, a, b) => a + b.replace(/[.,]/g, ""));
        setRaw(v);
        const n = parseHours(v);
        onChange(Number.isNaN(n) ? null : n);
      }}
      placeholder="es. 1,5"
      className={className}
      data-testid={testId}
    />
  );
}
